if ($('.js-file-upload-box').length) {
    /*
     * file upload
     */
    $(document).on('change', '.js-file-upload-box input[type="file"]', function () {
        const $input = $(this);
        const label = $input.val().replace(/\\/g, '/').replace(/.*\//, '');
        $input.parent().parent().next(':text').val(label);
        const name = $input.attr('name');
        const target = name.replace('upload_', '');
        const files = !!this.files ? this.files : [];

        if (!files.length || !window.FileReader)
            return; // no file selected, or no FileReader support
        if (/^image/.test(files[0].type)) { // only image file
            const reader = new FileReader(); // instance of the FileReader
            reader.readAsDataURL(files[0]); // read the local file
            reader.onloadend = function () { // set image data as background of div
                $('#preview_' + target)
                    .empty()
                    .append('<img src="' + this.result + '" alt="preview image">');
                $('#readonly_' + target).val(label);
            }
        } else {
            // FIXME: img/common/pdf.pngに置き換えるだけならファイルを読む必要ないような。それとpdf決めつけでいいのかどうか。
            const readerB = new FileReader(); // instance of the FileReader
            readerB.readAsDataURL(files[0]); // read the local file
            readerB.onloadend = function () { // set image data as background of div
                $('#preview_' + target)
                    .empty()
                    .append('<img src="'+ location.protocol+ '//' + location.host + '/img/common/pdf.png" alt="preview image">');
                $('#readonly_' + target).val(label);
            }
        }
    });

    /*
     * file delete
     */
    $(document).on('click', '.js-file-upload-box .delete-btn', function () {
        const target = $(this).attr('id').replace('delete_', '');
        $('*[name=' + target + ']').val('');
        $('#readonly_' + target).val('');
        $('#preview_' + target)
            .empty()
            .append('<img src="/img/common/no_photo.jpg" alt="preview image">');
    })
}
